import { Router } from '@angular/router';
import { AlertController, ModalController, NavController } from '@ionic/angular';

import { FirebaseAnalyticsService } from 'src/app/core/services/analytics/firebase-analytics.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment';
import { AccountService } from 'src/app/shared/services/account.service';
import { AgreementsService } from '../../../pages/agreements/services/agreements.service';
import { ConsumersService } from '../../services/consumers.service';
import { JobsService } from '../../services/jobs.service';
import { TimesheetsService } from '../../services/timesheets.service';

export abstract class NotificationBase {
  protected item: any;

  constructor(
    // !!! IMPORTANT !!! When adding new dependency, please update newNotification method in /src/app/shared/notification.provider.ts
    protected router: Router,
    protected navCtrl: NavController,
    protected alertCtrl: AlertController,
    protected agreementsService: AgreementsService,
    protected jobsService: JobsService,
    protected consumersService: ConsumersService,
    protected timesheetsService: TimesheetsService,
    protected pushData: any,
    protected modalCtrl: ModalController,
    protected auth: AuthService,
    protected accountService: AccountService,
    protected firebaseAnalyticsService: FirebaseAnalyticsService,
  ) {
    this.item = pushData.payload.item;
  }

  // Each kind of notification implements this in their specific way
  abstract process(): void;

  // Shows the alert to the user and returns the promise for chained actions
  showAlert(): Promise<any> {
    const isVideoChat = this.pushData.message.includes(`${environment.webAppUrl()}/lobbies/`);
    const confirmAlert = this.alertCtrl.create({
      header: this.pushData.title,
      cssClass: 'white-space-pre-wrap',
      message: isVideoChat ? 'Video chat invitation' : this.pushData.message,
      buttons: this.buttons(),
    });

    return confirmAlert.then((alert) => {
      alert.present();
    });
  }

  currentRoute(): string {
    return this.router.url;
  }

  // method to invoke when user clicks 'OK' button
  protected abstract viewNotification(): void;

  // Overridable method for alert button(s)
  protected buttons(): any {
    return [
      { text: 'Ignore', role: 'cancel' },
      { text: 'View', handler: () => this.viewNotification() },
    ];
  }
}
